export function mergeArraysToArray<T = any>(arrays: Array<Array<T>>): Array<T> {
  return [].concat.apply([], arrays);
}
